import { TZDate } from '@date-fns/tz';
import { addMinutes } from 'date-fns';
import { AddOnV3 } from '@kouto/types';
import parseDurationAsMinutes from 'utils/duration/parseDurationAsMinutes';
import parseSessionDateTime from 'utils/data/sessionDateTime/parseSessionDateTime';

const wallClockInZone = (instant: Date, timeZone: string): Date => {
  const inZone = TZDate.tz(timeZone, instant);
  return new Date(
    inZone.getFullYear(),
    inZone.getMonth(),
    inZone.getDate(),
    inZone.getHours(),
    inZone.getMinutes(),
  );
};

const isAddOnBookable = (
  addOn: Pick<AddOnV3, 'onlineBookingCutoffHours'>,
  session: {
    sessionDateTime: string;
    sessionDuration: string;
    timezone?: string;
  },
  currentTime: Date = new Date(),
): boolean => {
  try {
    const sessionStart = parseSessionDateTime(session.sessionDateTime);
    const sessionDurationMinutes = parseDurationAsMinutes(
      session.sessionDuration,
    );
    const cutoffHours = addOn.onlineBookingCutoffHours ?? 0;
    const cutoffMinutes =
      cutoffHours < 0 ? -sessionDurationMinutes : cutoffHours * 60;
    const cutoffDateTime = addMinutes(sessionStart, -cutoffMinutes);
    const now = session.timezone
      ? wallClockInZone(currentTime, session.timezone)
      : currentTime;

    return cutoffDateTime >= now;
  } catch {
    return true;
  }
};

export default isAddOnBookable;
